import { render, staticRenderFns } from "./softwareOilfield.vue?vue&type=template&id=7226c61c&scoped=true"
import script from "./softwareOilfield.vue?vue&type=script&lang=js"
export * from "./softwareOilfield.vue?vue&type=script&lang=js"
import style0 from "./softwareOilfield.vue?vue&type=style&index=0&id=7226c61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226c61c",
  null
  
)

export default component.exports